import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { faqApi } from '@/api/faq';
import { Faq } from '@/types';
import { useActionFeedback } from '@/hooks/useActionFeedback';

export const useFaqList = (params: { page?: number; limit?: number } = {}) =>
  useQuery({
    queryKey: ['faq', params],
    queryFn: () => faqApi.getAll(params),
  });

export const useCreateFaq = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: (data: Partial<Faq>) => faqApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['faq'] });
      feedback.success('FAQ berhasil dibuat');
    },
    onError: (error) => {
      feedback.error('Gagal membuat FAQ', error);
    },
  });
};

export const useUpdateFaq = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<Faq> }) => faqApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['faq'] });
      feedback.success('FAQ berhasil diperbarui');
    },
    onError: (error) => {
      feedback.error('Gagal memperbarui FAQ', error);
    },
  });
};

export const useDeleteFaq = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: (id: number) => faqApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['faq'] });
      feedback.success('FAQ berhasil dihapus');
    },
    onError: (error) => {
      feedback.error('Gagal menghapus FAQ', error);
    },
  });
};
